// extracted by mini-css-extract-plugin
export var Banner = "style-module--Banner--d401d";
export var Card = "style-module--Card--c661d";
export var Category = "style-module--Category--eeb92";
export var DescriptionWrapper = "style-module--DescriptionWrapper--5f867";
export var Details = "style-module--Details--5ba4b";
export var Image = "style-module--Image--43f10";
export var ImageWrapper = "style-module--ImageWrapper--50300";
export var ReadingTime = "style-module--ReadingTime--a0392";
export var Title = "style-module--Title--de70d";